<template>
  <vue-loading v-if="loading" :active.sync="loading" :is-full-page="true" loader="dots" color="#70A1F0"></vue-loading>
  <div v-else id="shelvery-summary">
    <div class="row">
      <div class="column">

        <div class="card">
          <div class="card-heading">
            <h4 style="float: left;" class="card-title">Shelvery Summary</h4>
            <button class="btn-primary" style="float: right; cursor: pointer;" v-on:click="downloadCSV">Download CSV</button>
          </div>
        </div>

        <template id="summary" v-if="summary != null">

            <template v-for="(data,service) in summary.summary">

                <div class="card" v-bind:key="service">
                  <div class="card-body">
                    <h3>{{service.toUpperCase()}}</h3>
                    <ul class="list-group">
                      <li class="d-flex justify-content-between align-items-center">
                        {{service}} resources with shelvery enabled
                        <span class="badge badge-success badge-pill">{{data.enabled}}</span>
                      </li>
                      <li class="d-flex justify-content-between align-items-center">
                        {{service}} resources with shelvery  disabled
                        <span class="badge badge-primary badge-pill">{{data.disabled}}</span>
                      </li>
                      <li class="d-flex justify-content-between align-items-center">
                        {{service}} resources with shelvery not configured
                        <span class="badge badge-pill" v-bind:class="{'badge-danger': data.not_configured > 0, 'badge-success': data.not_configured === 0}">{{data.not_configured}}</span>
                      </li>
                      <li class="d-flex justify-content-between align-items-center">
                        completed {{service}} backups
                        <span class="badge badge-success badge-pill">{{data.completed_backups}}</span>
                      </li>
                      <li class="d-flex justify-content-between align-items-center">
                        missing {{service}} backups
                        <span class="badge badge-pill" v-bind:class="{'badge-danger': data.missing_backups > 0, 'badge-success': data.missing_backups === 0}">{{data.missing_backups}}</span>
                      </li>
                    </ul>
                  </div>
                </div>

            </template>

        </template>
      </div>

      <div class="column">

        <div class="card">
          <div class="card-heading">
            <h4 class="card-title d-flex justify-content-between align-items-center">
              Shelvery Issues
              <span v-if="summary != null" class="badge badge-pill" v-bind:class="{'badge-danger': summary.issues.length > 0, 'badge-success': summary.issues.length === 0}">{{summary.issues.length}}</span>
            </h4>
          </div>
        </div>

        <template id="issues" v-if="summary != null">

          <template v-for="(miss,index) in summary.issues.missing">

            <div class="card issue-card" v-bind:key="index">
              <div class="issue-heading">
                <span><strong>{{miss.backup_type.toUpperCase()}} - {{miss.name}} </strong></span>
              </div>
              <div class="card-body issue-body">
                <p class="mb-1"><strong>reason:</strong> Missing {{miss.group}} backup for {{miss.date}}</p>
                <p class="mb-1"><strong>account:</strong> {{miss.account}} <strong>region:</strong> {{miss.region}}</p>
              </div>
            </div>

          </template>
        </template>

      </div>
    </div>
  </div>
</template>

<script>
import HTTP from '@/common/http'
import VueLoading from 'vue-loading-overlay'
import { mapGetters } from 'vuex'

export default {
  name: 'Shelvery',
  components: {
    VueLoading
  },
  props: [
    'id',
    'type'
  ],
  computed: {
    ...mapGetters([
      'activeType'
    ])
  },
  data () {
    return {
      summary: null,
      loading: false
    }
  },
  watch: {
    id: function () {
      this.getSummary()
    }
  },
  created: function () {
    this.getSummary()
  },
  methods: {
    downloadCSV: function () {
      this.flashMessage.info({
        message: 'Generating file...',
        time: 3000
      })
      HTTP.get(`/shelvery/summary/csv/${this.activeType}/${this.id}`)
        .then((response) => {
          window.location = response.data.signedUrl
          this.flashMessage.success({
            message: 'Successfully generated Shelvery CSV report'
          })
        })
        .catch((error) => {
          this.flashMessage.error({
            message: `Failed to generate Shelvery CSV report : ${error.message}`
          })
        })
    },
    getSummary: function () {
      this.loading = true
      this.summary = null
      HTTP.get(`/shelvery/summary/${this.activeType}/${this.id}`)
        .then((response) => {
          this.summary = response.data
        })
        .catch((error) => {
          this.flashMessage.error({
            message: `Failed to get Shelvery summary : ${error.message}`
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
<style scoped>
ul {
  list-style-type: none;
  padding: 0;
  text-align: center;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  cursor: pointer;
}
.box {
  padding-top: 20px;
}
.row {
  display: flex;
  padding-left: 20px;
  padding-right: 20px;
}
.column {
  padding-top: 15px;
  flex-direction: column;
  display: flex;
  overflow: hidden;
  flex: 1;
}
.card {
  transition: opacity 200ms;
  background: #ffffff;
  width: auto;
  margin: 5px 15px 10px 15px;
  padding: 15px 15px 5px 15px;
  display: flex;
  align-self: left;
  border: none;
  border-radius: 0;
  box-sizing: content-box;
  box-shadow: 0 2px 17px -5px rgba(0,0,0,0.2);
}
.card-title {
  padding-left: 10px;
}
.issue-card {
  border-right: 6px solid #bd3e32;
}
.issue-heading {
  font-size: medium;
  border-bottom: 1px solid #d0d0d0;
}
.issue-body {
  padding: 5px 0 0 15px;
}
.progress-list {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/Shelvery.vue